import { UserManagerSettings } from "oidc-client";
import { Constants } from "../../Variables/StaticVariables";

export const oAuthSettings = {
    authority: Constants.stsAuthority,
    client_id: Constants.clientId,
    redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${process.env.PUBLIC_URL}/signin-callback`,//`${Constants.clientRoot}/signin-callback.html`,
    silent_redirect_uri: `${Constants.clientRoot}/silent-renew`,
    automaticSilentRenew: true,
    post_logout_redirect_uri: `${Constants.clientRoot}`,
    response_type: "code",
    scope: Constants.clientScope,
    validateSubOnSilentRenew: false,
    includeIdTokenInSilentRenew: true,
    silentRequestTimeoutInSeconds: 30,
    //Store access token in local storage so a new token doen't need to be fetch when opening a ticket in a new tab.
    // stateStore: new WebStorageStateStore({
    //     store: localStorage
    // }),
} as UserManagerSettings;